<template>
    <div>
商家审核
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
    }
</script>

<style lang="less" scoped>

</style>